import type { Vault } from '@/types/vault'
import { getCuratorDisplayName } from '@/utils/curator'
import { getProtocolDisplayName } from '@/utils/protocol'
import Fuse from 'fuse.js'
import { getNetworkName } from '../network/getNetworkName'
import { getOverwrittenTokenSymbol } from '../tokens/getOverwrittenTokenSymbol'

const SEARCH_KEYS = [
  'name',
  'protocol.name',
  'network.name',
  'token.name',
  'token.symbol',
  'curator.name',
  'tags',
] satisfies Fuse.FuseOptionKey<Vault>[]
const FORMATTED_NETWORK_SEARCH_KEY = 'formattedNetwork'
const FORMATTED_TOKEN_SEARCH_KEY = 'formattedToken'
const FORMATTED_PROTOCOL_SEARCH_KEY = 'formattedProtocol'
const FORMATTED_CURATOR_SEARCH_KEY = 'formattedCurator'

const SEARCH_OPTIONS: Fuse.IFuseOptions<Vault> = {
  ignoreLocation: true,
  threshold: 0.1,
  keys: SEARCH_KEYS,
}

export function searchVaults(vaults: Vault[], searchFor: string) {
  const formattedVaults = vaults.map((vault) => ({
    ...vault,
    [FORMATTED_NETWORK_SEARCH_KEY]: getNetworkName(vault.network.name),
    [FORMATTED_TOKEN_SEARCH_KEY]: getOverwrittenTokenSymbol(vault.asset.symbol),
    [FORMATTED_PROTOCOL_SEARCH_KEY]: getProtocolDisplayName(vault.protocol),
    [FORMATTED_CURATOR_SEARCH_KEY]: vault.curator ? getCuratorDisplayName(vault.curator) : '',
  }))
  const searchTerms = searchFor.split(' ')
  const searchResult = searchTerms.reduce((searchResults, searchTerm) => {
    if (!searchTerm || searchTerm === ' ') return searchResults
    const fuse = new Fuse(searchResults, {
      ...SEARCH_OPTIONS,
      keys: [
        ...SEARCH_KEYS,
        FORMATTED_NETWORK_SEARCH_KEY,
        FORMATTED_TOKEN_SEARCH_KEY,
        FORMATTED_PROTOCOL_SEARCH_KEY,
        FORMATTED_CURATOR_SEARCH_KEY,
      ],
    })
    return fuse.search(searchTerm).map((e) => e.item)
  }, formattedVaults)
  return searchResult
}
